import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
import store from "../..";

const state = {
  leaves: [],
  leave: {},
  roles: [],
  possibleStatus: [],
  pagination: {},
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
  cutLeaveStatus: false,
  extendLeaveStatus: false,
  approveLeaveStatus: false,
  changeStatus: false,
};
const getters = {
  leavesListGet: (state) => state.leaves,
  // rolesListGet: (state) => state.roles,
  leaveGet: (state) => state.leave,
  possibleStatus: (state) => state.possibleStatus,
};
const actions = {
  getLeaves({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`employee_vacations?page=${page}`).then(
      (obj) => {
        var result = obj.data.employee_vacation;
        const pageresult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: obj.data.per_page,
          total: obj.data.total,
        };
        commit("leavesListSet", result);
        commit("setPagination", pageresult);
      },
      (error) => {
        console.log("leaves..." + error);
        toastError(error);
      }
    );
  },
  async getPossibleStatus({ commit }, payload) {
    const result = await service.getFun(
      `employee_vacations/possible_status/${payload.id}`
    );
    if (result) {
      commit("setPossibleStatus", result.data);
    }
  },
  addLeave({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `employee_vacations/store`,
        null,
        {
          action: "getLeaves",
        }
      )
      .then(
        (result) => {
          commit("addLeaveStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  getLeaveById({ commit }, payload) {
    service.getFun(`leaves/${payload.id}`).then(
      (obj) => {
        var result = obj.data;
        commit("getLeaveById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  async editLeave({ commit }, payload) {
    console.log("Edit");
    const result = await service.postFun(
      payload,
      `employee_vacations/edit/${payload.id}`,
      null,
      {
        action: "getLeaves",
      }
    );
    if (result) {
      commit("setLeaveEdit", result.success);
      toast(result.message);
    }
  },
  deleteLeave({ commit }, payload) {
    service
      .postFun(null, `employee_vacations/delete/${payload.payload}`, null, {
        action: "getLeaves",
      })
      .then(
        (result) => {
          commit("deleteLeaveStatus", result?.success);
          toast(result?.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  async extendLeave({ commit }, payload) {
    const result = await service.postFun(
      payload,
      `employee_vacations/extend_vacation/${payload.id}`,
      null,
      {
        action: "getLeaves",
      }
    );
    if (result) {
      commit("setExtendLeave", result.success);
      toast(result.message);
    }
  },

  async cutLeave({ commit }, payload) {
    const result = await service.postFun(
      payload,
      `employee_vacations/cut/${payload.id}`,
      null,
      {
        action: "getLeaves",
      }
    );
    if (result) {
      commit("setCutLeave", result.success);
      toast(result.message);
    }
  },

  async approveLeave({ commit }, payload) {
    const result = await service.postFun(
      payload,
      `employee_vacations/approve_vacation/${payload.id}`,
      null,
      {
        action: "getLeaves",
      }
    );
    if (result) {
      commit("setApproveLeave", result.success);
      toast(result.message);
    }
  },

  async changeLeaveStatus({ commit }, payload) {
    const result = await service.postFun(
      payload,
      `employee_vacations/update_vacation_status/${payload.id}`,
      null,
      {
        action: "getLeaves",
      }
    );
    if (result) {
      commit("setChangeStatus", result.success);
      toast(result.message);
    }
  },
};
const mutations = {
  leavesListSet(state, leaves) {
    state.leaves = leaves;
  },
  // rolesListSet(state, roles) {
  //   state.roles = roles;
  // },
  getLeaveById(state, leave) {
    state.leave = leave;
  },
  addLeaveStatus(state, Status) {
    state.addStatus = Status;
  },
  setLeaveEdit(state, Status) {
    state.editStatus = Status;
  },
  deleteLeaveStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
  setCutLeave(state, payload) {
    state.cutLeaveStatus = payload;
  },
  setExtendLeave(state, payload) {
    state.extendLeaveStatus = payload;
  },
  setApproveLeave(state, payload) {
    state.approveLeaveStatus = payload;
  },
  setChangeStatus(state, payload) {
    state.changeStatus = payload;
  },
  setPossibleStatus(state, payload) {
    state.possibleStatus = payload;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
